const DocNodeSpec = {
  content: "block+",
};

export default DocNodeSpec;
